import Vue from 'vue'
import Vuex from 'vuex'
import * as Api from '@/api/CartApi'
import * as Analytics from '@/api/AnalyticsApi'
import { CartPageModel } from '@ViewModels/CartPageModel'
import { CartTotalsModel } from '@ViewModels/CartTotalsModel'

Vue.use(Vuex)

export interface CartState {
   modelDataLoaded: boolean
   modelData: CartPageModel
}

export default new Vuex.Store<CartState>({
   state: {
      modelDataLoaded: false,
      modelData: {
         Id: '',
         CartItems: [],
         Totals: {} as CartTotalsModel,
         PromoCodes: [],
         CurrencyCode: '',
         CurrencySymbol: '$',
         CountryCode: '',
         MarketId: '',
         MarketName: '',
         ShippingCountryId: '',
         AllowClickAndCollect: false,
         ClickAndCollect: false,
         CurrencyId: '',
         GSTPercentage: 0,
         StoreCreditAvailable: 0,
         HasStoreCreditAvailable: false,
         HasPhysicalProducts: true,
         HasDigitalProducts: true,
         HasVitalSourceProducts: true,
         PromoteSubscription: false,
         UseGoogleAnalytics: false,
         UseFacebookAnalytics: false,
      } as CartPageModel,
   },
   mutations: {
      setModelData: (state, model: CartPageModel) => {
         Vue.set(state, 'modelData', model)
         state.modelDataLoaded = true
      },
   },
   actions: {
      async loadModelData({ state, commit }) {
         if (!state.modelDataLoaded) {
            const model = await Api.getModelData()
            commit('setModelData', model)
            Analytics.viewCart(state.modelData)
         }
      },
      async refreshModelData({ commit }) {
         const model = await Api.getModelData()
         commit('setModelData', model)
         return model
      },
      async updateCartQuantity(
         { state, commit },
         payload: { productPriceId: string; quantity: number }
      ) {
         try {
            if (payload.quantity === 0) {
               Analytics.removeFromCart(state.modelData, payload.productPriceId)
            }
            const result: CartPageModel = await Api.updateCartItem(
               payload.productPriceId,
               payload.quantity
            )
            commit('setModelData', result)
            return true
         } catch (err) {
            commit('setErrorMessage', err)
            return false
         }
      },
      async applyPromocode({ dispatch }, code: string) {
         const result = await Api.addPromocode(code)
         if (result.HasError) {
            return result
         }
         await dispatch('refreshModelData')
         return result
      },
      async removePromocode({ dispatch }, code: string) {
         const result = await Api.removePromocode(code)
         if (result.HasError) {
            return result
         }
         await dispatch('refreshModelData')
         return result
      },
      async recoverCartItems({ dispatch }, cartId: string) {
         if (!cartId) {
            return
         }
         const result = await Api.recoverCart(cartId)
         if (result.HasError) {
            return result
         }
         await dispatch('refreshModelData')
         return result
      },
   },
   getters: {
      requiresDelivery(state: CartState): boolean {
         return state.modelData.HasPhysicalProducts
      },
      allowClickAndCollect(state: CartState): boolean {
         return state.modelData.AllowClickAndCollect
      },
      clickAndCollect(state: CartState): boolean {
         return state.modelData.AllowClickAndCollect && state.modelData.ClickAndCollect
      },
      currencyCode(state): string {
         return state.modelData.CurrencyCode
      },
      useStoreCredit(state): boolean {
         return false
      },
   },
})
